import { Grid as MantineGrid, GridProps } from "@mantine/core";

export const Grid = (props: GridProps) => {
  return <MantineGrid {...props} />;
};

Grid.Col = MantineGrid.Col;
